export function formatDateToCustomString(dateString) {
  //   console.log("dateString", dateString);
  const dateArr = dateString.map((e) => {
    // console.log(e);
    const date = new Date(e);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}${month}${day}`;
  });
  return dateArr;
}
